/* tslint:disable */
/* eslint-disable */
/**
 * Common
 * 共通API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetPrefectures200ResponseAllOfData } from './GetPrefectures200ResponseAllOfData';
import {
    GetPrefectures200ResponseAllOfDataFromJSON,
    GetPrefectures200ResponseAllOfDataFromJSONTyped,
    GetPrefectures200ResponseAllOfDataToJSON,
} from './GetPrefectures200ResponseAllOfData';

/**
 * 
 * @export
 * @interface GetPrefectures200Response
 */
export interface GetPrefectures200Response {
    /**
     * 
     * @type {GetPrefectures200ResponseAllOfData}
     * @memberof GetPrefectures200Response
     */
    data: GetPrefectures200ResponseAllOfData;
    /**
     * 
     * @type {object}
     * @memberof GetPrefectures200Response
     */
    meta: object;
}

/**
 * Check if a given object implements the GetPrefectures200Response interface.
 */
export function instanceOfGetPrefectures200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "meta" in value;

    return isInstance;
}

export function GetPrefectures200ResponseFromJSON(json: any): GetPrefectures200Response {
    return GetPrefectures200ResponseFromJSONTyped(json, false);
}

export function GetPrefectures200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPrefectures200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': GetPrefectures200ResponseAllOfDataFromJSON(json['data']),
        'meta': json['meta'],
    };
}

export function GetPrefectures200ResponseToJSON(value?: GetPrefectures200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': GetPrefectures200ResponseAllOfDataToJSON(value.data),
        'meta': value.meta,
    };
}

